export default __webpack_public_path__ + "static/media/banner_calender.718cd773.svg";